<template>
    <div class="discuss-choose-people layout-sub-page">
        <!-- 1、标题栏 -->
        <title-bar
            v-bind:className="'discuss-chpp-title'"
            v-bind:titleData="titleData"
            v-bind:backFunc="clickBack"
            v-bind:createGray="lunpanRoomSelectedUserData.length == 0"
            v-bind:createFunc="clickSelect">
        </title-bar>
        <div class="discuss-choose-people-content">
            <!-- 2、搜索框 -->
            <div class="discuss-choose-people-search">
                <search-input 
                    v-bind:inputId="searchInputId"
                    v-bind:searchData="searchData"
                    v-bind:inputFunc="inputSearch">
                </search-input>
            </div>

            <!-- 3、列表部分 -->
            <div ref="list" v-if="lunpanRoomAllUserKeys.length > 0" class="discuss-choose-people-list">
                <van-index-bar :index-list="lunpanRoomAllUserKeys">
                    <section v-for="(userList, key) in lunpanRoomAllUserObject" v-bind:key="'userSectioin'+key">
                        <van-index-anchor v-bind:index="key" />
                        <discuss-choose-item
                            v-for="userData of userList"
                            v-bind:key="'user'+userData.id"
                            v-bind:itemData="userData"
                            v-bind:itemFunc="clickUserItem">
                        </discuss-choose-item>   
                    </section>
                </van-index-bar>
            </div>
            <div v-else-if="searchText != ''" class="discuss-choose-people-no-data">
                <p>没有找到<span>“{{searchText}}”</span>相关成员</p>
            </div>
        </div>
    </div>
</template>

<script>
import TitleBar from '../../components/TitleBar.vue'
import DiscussChooseItem from '../../components/discuss/DiscussChooseItem.vue'
import SearchInput from '../../components/SearchInput.vue'
export default {
    name: 'DiscussChoosePeople',
    components: { TitleBar, SearchInput, DiscussChooseItem },
    computed: {
        searchData() {
            return this.$store.state.search.searchData;
        },
        lunpanData() {
            return this.$store.state.discuss.lunpanData;
        },
        lunpanRoomAllUserKeys() {
            return this.$store.state.discuss.lunpanRoomAllUserKeys;
        },
        lunpanRoomAllUserObject() {
            return this.$store.state.discuss.lunpanRoomAllUserObject;
        },
        lunpanRoomSelectedUserData() {
            return this.$store.state.discuss.lunpanRoomSelectedUserData;
        }
    },
    data() {
        return {
            titleData: {
                'titleText': '选择提醒的人', 
                'titleCreate': '确定',
                'showCancel': false
            },
            searchInputId: 'discussChooseSearch',
            searchText: ''            
        }
    },
    mounted() {
        this.$store.dispatch('discuss/initLunPanRoomConfig', {
            id: this.lunpanData.rid
        });
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 20);
    },
    methods: {
        initDom() {
            this.$el.style.height = innerHeight+'px';
            var titleBar = document.getElementsByClassName('discuss-chpp-title')[0],
                searchDiv = document.getElementsByClassName('discuss-choose-people-search')[0];
            if(this.$refs.list) {
                this.$refs.list.style.height = (innerHeight - titleBar.clientHeight - searchDiv.clientHeight)+'px';
            }
            // console.error('initDom------', this.$refs.list)
        },
        clickBack() {
            this.$router.go(-1);
            this.$store.dispatch('search/resetData');
            this.$bus.emit('triggerBindKeyDownEvent');
            this.$bus.emit('updateDiscussAtText');
        },
        clickSelect() {
            if(this.lunpanRoomSelectedUserData.length > 0) {
                this.setAtListSucBack();
            }
        },
        inputSearch(text) {
            this.searchText = text;
            if(text != '') {
                // console.error('开始搜索', text);
                this.$store.dispatch('discuss/searchLunpanRoomAllUserObject', text);
            }else {
                this.$store.dispatch('discuss/resetLunpanRoomAllUserObject');
            }
        },
        clickUserItem(itemData) {
            this.$store.dispatch('discuss/toggleLunPanRoomAllUserObjectSelected', itemData);
        },
        setAtListSucBack() {
            var curPath = this.$router.history.current.path;
                curPath = curPath.replace('/choosepeople', '');
            this.$router.replace(curPath);
            this.$bus.emit('updateDiscussAtText');
        }
    }
}
</script>